module.exports = [
  {
    title: 'Introduction to Kubernetes LFS158',
    issuer: 'The Linux Foundation',
    date: '2026-07',
    credentialId: 'LF-g4at1tt3p6',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-0657e4db-790b-4bda-8393-4025a5a0cc13-certificate.pdf'
  },
  {
    title: 'Siber Tehdit İstihbaratı ve Tehdit Avcılığı',
    issuer: 'BTK Akademi',
    date: '2026-07',
    credentialId: 'jK1hG7blmK',
    logo: '/images/certs/btk.webp',
    link: 'https://www.btkakademi.gov.tr/portal/certificate/validate?certificateId=jK1hG7blmK'
  },
  {
    title: 'Kubernetes',
    issuer: 'BTK Akademi',
    date: '2026-07',
    credentialId: 'qKrheEmkax',
    logo: '/images/certs/btk.webp',
    link: 'https://www.btkakademi.gov.tr/portal/certificate/validate?certificateId=qKrheEmkax'
  },
  {
    title: 'Certificate of Completion: Claude Code 101',
    issuer: 'Anthropic',
    date: '2026-06',
    credentialId: '6a3ydv92jpzm',
    logo: '/images/certs/anthropic.jpg',
    link: 'https://verify.skilljar.com/c/6a3ydv92jpzm'
  },
  {
    title: 'Claude Code in Action',
    issuer: 'Anthropic',
    date: '2026-06',
    credentialId: 'c6jp2juu259eg',
    logo: '/images/certs/anthropic.jpg',
    link: 'https://verify.skilljar.com/c/c6jp2juu259eg'
  },
  {
    title: 'Ethical Hacker',
    issuer: 'Cisco',
    date: '2026-03',
    credentialId: '',
    logo: '/images/certs/cisco.webp',
    link: 'https://www.credly.com/badges/fcfd31d2-ac0f-44ec-8c43-d941c0243aed'
  },
  {
    title: 'Introduction to Cybersecurity',
    issuer: 'Cisco',
    date: '2026-03',
    credentialId: '',
    logo: '/images/certs/cisco.webp',
    link: 'https://www.credly.com/badges/aee2ee1b-42f1-4ed8-8fec-313c2fb38ad4'
  },
  {
    title: 'Digital Forensics',
    issuer: 'BTK Akademi',
    date: '2026-03',
    credentialId: 'eK1hObN1YN',
    logo: '/images/certs/btk.webp',
    link: 'https://www.btkakademi.gov.tr/portal/certificate/validate?certificateId=eK1hObN1YN'
  },
  {
    title: 'Introduction to Programming with C++',
    issuer: 'BTK Akademi',
    date: '2026-03',
    credentialId: 'OKMhqA44X8',
    logo: '/images/certs/btk.webp',
    link: 'https://www.btkakademi.gov.tr/portal/certificate/validate?certificateId=OKMhqA44X8'
  },
  {
    title: 'Software Engineering Basics for Embedded Systems LFD116',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF-lbixufkdns',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-669c6e26-c6df-413a-bd4f-d9e875e7e4c9-certificate.pdf'
  },
  {
    title: 'A Beginner\'s Guide to Linux Kernel Development LFD103',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF-j2523ahsds',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-7d5d4b32-90d6-492c-9d67-beca10c83f06-certificate.pdf'
  },
  {
    title: 'XSS Exploits and Defenses LFEL1010',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF91annvj9ux',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-b901153d-f046-4e40-887f-04cfa7f58213-certificate.pdf'
  },
  {
    title: 'Securing Projects with OpenSSF Scorecard LFEL1006',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF-qudxd7s5vz',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-216e921c-ef5d-4bca-a387-98453d3b978f-certificate.pdf'
  },
  {
    title: 'Introduction to Zero Trust LFS183',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF-qkf4j0ueea',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-3855735a-c82e-4e47-a0e7-a5fec24c10ae-certificate.pdf'
  },
  {
    title: 'Cybersecurity Essentials LFC108',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF-lgsruoe6g4',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-39d7b087-a3e6-423f-b133-950724ded520-certificate.pdf'
  },
  {
    title: 'Getting Started with Rust LFEL1002',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF-sllvq1cb0z',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-0ced1268-1c50-45d3-9fbc-6d76ae338bd6-certificate.pdf'
  },
  {
    title: 'Porting Software to RISCV LFD114',
    issuer: 'The Linux Foundation',
    date: '2026-02',
    credentialId: 'LF-e27w6eo7d4',
    logo: '/images/certs/tlf.webp',
    link: 'https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/2fc4ebaf-a514-4d5b-bcaf-9d4df0448cc3-melih-emik-4c2ecf2c-71d9-4352-b0aa-faf3c62215d6-certificate.pdf'
  },
  {
    title: 'Rust Programming Language',
    issuer: 'BTK Akademi',
    date: '2026-02',
    credentialId: 'XV1hBKv9XN',
    logo: '/images/certs/btk.webp',
    link: 'https://www.btkakademi.gov.tr/portal/certificate/validate?certificateId=XV1hBKv9XN'
  },
  {
    title: 'Introduction to Programming with Go',
    issuer: 'BTK Akademi',
    date: '2026-01',
    credentialId: 'mKEhkVPLkk',
    logo: '/images/certs/btk.webp',
    link: 'https://www.btkakademi.gov.tr/portal/certificate/validate?certificateId=mKEhkVPLkk'
  },
  {
    title: 'C Programming Language',
    issuer: 'BTK Akademi',
    date: '2026-01',
    credentialId: 'oJpS7BGGlp',
    logo: '/images/certs/btk.webp',
    link: 'https://www.btkakademi.gov.tr/portal/certificate/validate?certificateId=oJpS7BGGlp'
  },
  {
    title: 'Certified Associate Penetration Tester (CAPT)',
    issuer: 'Hackviser',
    date: '2026-01',
    credentialId: 'HV-CAPT-28KG4MAY',
    logo: '/images/certs/hackviser.webp',
    link: 'https://hackviser.com/verify?id=HV-CAPT-28KG4MAY'
  },
  {
    title: 'Certified Cybersecurity Foundations',
    issuer: 'Hackviser',
    date: '2026-07',
    credentialId: 'HV-CORE-3X6O1LYY',
    logo: '/images/certs/hackviser.webp',
    link: 'https://hackviser.com/verify?id=HV-CORE-3X6O1LYY'
  }
];

// Commit trace: 2025-12-25T15:02:08 - style: improve code style in certificates.js
